export const ukCatalog = {
  locale: 'uk-UA',
  htmlLang: 'uk',
  messages: {
    'nav.stations': 'Станції',
    'nav.schedule': 'Розклад',
    'nav.library': 'Медіатека',
    'nav.transitions': 'Переходи',
    'nav.studio': 'Ефірна студія',
    'nav.mobile': 'Мобільний пульт',
    'nav.monitoring': 'Моніторинг',
    'nav.account': 'Безпека акаунта',
    'library.title': 'Медіатека та підготовка ефіру',
    'library.upload': 'Додати аудіофайли',
    'library.empty': 'У медіатеці ще немає аудіо',
    'library.emptyDetail': 'Додайте пісню, джингл або свіпер. Після автоматичного аналізу файл з’явиться в редакторі.',
    'library.search': 'Пошук за назвою або виконавцем',
    'library.saveMetadata': 'Зберегти опис',
    'library.saveCues': 'Зберегти точки й фейди',
  },
  itemTypes: {
    TRACK: 'Пісня',
    JINGLE: 'Джингл',
    SWEEPER: 'Свіпер',
    LINER: 'Лайнер',
    STINGER: 'Стінгер',
    BED: 'Музична підкладка',
    PROMO: 'Промо',
    ADVERTISEMENT: 'Реклама',
    VOICE_TRACK: 'Голосова доріжка',
    PROGRAM_ITEM: 'Елемент програми',
  },
  transitionModes: {
    HARD: 'Без переходу',
    FADE: 'Плавне згасання',
    CROSSFADE: 'Перехресний фейд',
    SMART: 'Розумний перехід',
    OVERLAY: 'Накладання',
    DUCK: 'Накладання з приглушенням',
  },
  stationModes: {
    AUTO: 'Автоматичний ефір',
    ASSIST: 'Ефір із ручним керуванням',
    LIVE: 'Прямий ефір',
    EMERGENCY: 'Аварійний ефір',
    DISABLED: 'Вимкнено',
  },
  engineStates: {
    STARTING: 'Запускається',
    ON_AIR: 'В ефірі',
    DEGRADED: 'Погіршений стан',
    FAILED: 'Помилка',
    STOPPED: 'Зупинено',
    OFFLINE: 'Немає зв’язку',
  },
  connectionQualities: {
    EXCELLENT: 'Відмінна',
    GOOD: 'Добра',
    DEGRADED: 'Нестабільна',
    UNSTABLE: 'Нестабільна',
    POOR: 'Погана',
    OFFLINE: 'Немає зв’язку',
  },
  healthStates: {
    HEALTHY: 'Справно',
    DEGRADED: 'Погіршено',
    CRITICAL: 'Критично',
    DISABLED: 'Вимкнено',
  },
  incidentStates: {
    OPEN: 'Відкрито',
    ACKNOWLEDGED: 'Підтверджено',
    RESOLVED: 'Усунуто',
  },
  severities: {
    INFO: 'Інформація',
    WARNING: 'Попередження',
    CRITICAL: 'Критично',
  },
  slotTypes: {
    ROTATION: 'Ротація',
    ITEM: 'Окремий матеріал',
    MARKER: 'Мітка',
    EXACT: 'Точна подія',
  },
  sourceKinds: {
    AUTO: 'Автоматично',
    MANUAL: 'Ручна вставка',
    EXACT: 'Точна подія',
    EMERGENCY: 'Аварійне джерело',
    CLOCK_ROTATION: 'Планова ротація',
    CLOCK_ITEM: 'Матеріал із розкладу',
    CLOCK_FLEX: 'Автоматичний добір',
    EXACT_EVENT: 'Точна подія',
    MANUAL_INSERT: 'Ручна вставка',
  },
  cartModes: {
    IMMEDIATE: 'Одразу',
    QUEUE: 'У чергу',
    OVERLAY: 'Накласти',
    NEXT_TRANSITION: 'На наступному переході',
  },
  apiErrors: {
    request_failed: 'Запит не виконано. Перевірте з’єднання й повторіть дію.',
    permission_denied: 'Для цієї дії бракує дозволу.',
    validation_failed: 'Перевірте заповнені поля.',
    track_not_found: 'Аудіоматеріал не знайдено.',
    track_revision_mismatch: 'Матеріал уже змінено в іншому вікні. Оновіть дані.',
    track_revision_conflict: 'Матеріал одночасно змінив інший користувач. Оновіть дані.',
    cue_revision_mismatch: 'Точки відтворення вже змінено в іншому вікні. Оновіть дані.',
    cue_revision_conflict: 'Точки відтворення одночасно змінив інший користувач.',
    media_too_large: 'Файл перевищує дозволений розмір.',
    media_quota_exceeded: 'У сховищі недостатньо місця.',
    media_analysis_unavailable: 'Файл збережено, але аналіз поки недоступний. Повторне додавання цього файла безпечне.',
    media_storage_unavailable: 'Сховище аудіо тимчасово недоступне.',
    upload_failed: 'Не вдалося прийняти аудіофайл.',
    invalid_credentials: 'Електронна пошта або пароль неправильні.',
    invalid_second_factor: 'Код другого фактора неправильний.',
    runtime_revision_mismatch: 'Стан ефіру вже змінився. Дані оновлено — перевірте їх і повторіть дію.',
    station_capacity_exceeded: 'На цьому медіавузлі немає вільного місця для ще однієї активної станції.',
    station_capacity_unavailable: 'Перевірка місткості тимчасово зайнята. Повторіть дію за кілька секунд.',
    station_revision_mismatch: 'Налаштування станції вже змінилися. Дані оновлено — перевірте їх і повторіть дію.',
    station_revision_conflict: 'Станцію одночасно змінив інший користувач. Оновіть дані.',
    station_slug_conflict: 'Станція з такою адресою потоку вже існує.',
  },
} as const;

export type UkCatalog = typeof ukCatalog;
